import { render, staticRenderFns } from "./pageType.vue?vue&type=template&id=3392f214&scoped=true&"
import script from "./pageType.vue?vue&type=script&lang=js&"
export * from "./pageType.vue?vue&type=script&lang=js&"
import style0 from "./pageType.vue?vue&type=style&index=0&id=3392f214&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3392f214",
  null
  
)

component.options.__file = "pageType.vue"
export default component.exports